
//
// No extension here: downloadFileFromUrl appends the file type itself.
const buildReportCardFileName = (
  studentName: string,
  termNames: string[],
  academicYear: string,
  fallbackFileName?: string
): string => {
  // Strip characters that are illegal or awkward in a downloaded file name.
  const clean = (value: string) =>
    value
      .replace(/[\\/:*?"<>|]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  if (!studentName) {
    return fallbackFileName || `report-card-${academicYear}`;
  }

  const period =
    termNames && termNames.length > 0
      ? termNames.map(clean).join(', ')
      : academicYear;

  return `${clean(studentName)} - ${period} - Report Card`;
};

export default buildReportCardFileName;
